import React from "react";
import { Grid, Typography } from "@material-ui/core";
import useStyles from "../../styles";
import CobeeTextField from "../../../../../CobeeTextField";

export default function RowCustomQuota({
  renting,
  setRenting,
  title,
  label,
}: {
  renting: string | number;
  setRenting(e: any): void;
  title: string;
  label: string;
}): JSX.Element {
  const { secondColumn, fieldRowSpacing, inputLabel, inputTopLabel } =
    useStyles();
  return (
    <>
      <Grid container item justifyContent="flex-end" xs={12}>
        <Grid
          item
          xs={6}
          container
          alignItems="center"
          className={secondColumn}
        >
          <Grid item xs={12} className={inputTopLabel}>
            <Typography variant="body2">{title}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container item justifyContent="flex-end" xs={12}>
        <Grid
          item
          xs={6}
          container
          alignItems="center"
          className={secondColumn}
        >
          <Grid
            item
            xs={12}
            container
            alignItems="center"
            className={fieldRowSpacing}
          >
            <Grid item xs={4}>
              <CobeeTextField
                styleType="default"
                variant="outlined"
                type="number"
                minWidth="100%"
                min={0}
                max={999}
                step="1"
                value={renting}
                onChange={(e) => setRenting(e.target.value)}
              />
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body2" className={inputLabel}>
                {`EUR (${label})`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
